import * as React from "react";
import { generalStore } from "../../../stores/GeneralStore";
import { history } from "./history";

type State = {
    lastLocation: any;
};

export class RoutingManager extends React.Component<any, State> {
    state: State = {
        lastLocation: history.location
    };

    componentDidMount() {
        history.listen((location: any, action: any) => {
            if (location !== this.state.lastLocation) {
                console.log(
                    `%cSwitching url to "${location.pathname}${location.search}${location.hash}" by action ${action}.`,
                    "background: #eee; color: #666;"
                );
                this.setState({
                    lastLocation: location
                });
                generalStore.lastLocation = location;
            }
        });
    }

    render() {
        return <>{this.props.children}</>;
    }
}
